import classNames from "classnames";
import React from "react";
import noChats from "./assets/noChats.svg";

const BlockedChats = () => {
  return (
    <div
      className={classNames("flex flex-col items-center justify-center")}
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "18px",
        padding: "0 24px",
        height: "100%",
      }}
    >
      <div className="flex flex-col items-center justify-center">
        <img src={noChats} alt="" className="mb-3" />
        <span
          className={classNames("mb-2")}
          style={{
            lineHeight: "24px",
            fontSize: "20px",
            color: "#83c1f5",
            fontWeight: 700,
          }}
        >
          Access Restricted
        </span>
        <span
          style={{
            lineHeight: "20px",
            fontSize: "16px",
            color: "#83c1f5",
            fontWeight: 400,
          }}
        >
          Your chat access has been suspended due to a violation of our
          community guidelines.
        </span>
      </div>
    </div>
  );
};
export default BlockedChats;
